<script setup>
import {onBeforeMount, ref, reactive} from "vue";
import {userInfoStore} from "@/store/store.js";
import {userLogoutHooks} from "@/hooks/user.js";
import router from "@/router/index.js";
import rules from "@/utils/validator-rules.js";
import {getPopupState} from "@/api/popup/popup.js";
import {editPassword} from "@/api/password/password.js";
const info = userInfoStore().info;

const user = {
  fullName: info.nickname ? info.nickname : info.username,
  email: info.email ? info.email : '-',
  avatar: info.avatar ? info.avatar : '',
}
const handleLogout = () => {
  userLogoutHooks()
}
const handleEdit = () => {
  router.push("/editAccountInformation")
}

// 父组件传值
const props = defineProps({
  // 面包屑导航信息
  bread: {
    type: Array,
    default: () => []
  }
})

const cutName = (name) => {
  return rules.isChinese(name.slice(0, 2)) ? name.slice(0, 1) : name.slice(0, 2)
}

onBeforeMount(() => {
  console.log("onBeforeMount run in header")
  // 检测当前用户是否初始密码
  // handleCheckPwdHasChange()
})

// 处理密码修改弹窗
const handleCheckPwdHasChange = async () => {
  // 请求接口
  let param = {
    loginType: "ADMIN",
    bizType: "ADMIN_PASSWORD_RESET"
  }
  const res = await getPopupState(param)
  console.log("res", res)
  if (res === "NOT_COMPLETED") {
    open.value = true
  }
}

// 修改密码对话框打开状态
const open = ref(false)
// 处理修改密码对话框关闭
const handleClose = () => {

}
// 处理修改密码对话框提交表单
const submit = async () => {
  await ruleFormRef.value.validate(async (valid, field) => {
    if (valid) {
      let param = {
        password: ruleForm.password
      }
      await editPassword(param)
      // 修改成功重新登录
      ElMessage.success("密码修改成功，请重新登录")
      userLogoutHooks()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}

// 表单锚点
const ruleFormRef = ref()
// 表单信息
const ruleForm = reactive({
  password: null,
  replyPwd: null
})
// 确认密码校验规则
const checkReplyPwd = (rule, value, callback) => {
  if (!value) return callback(new Error("请输入新密码"))
  if (value !== ruleForm.password) return callback(new Error("两次输入的新密码不一致"))
  return callback()
}
// 表单校验规则
const formRules = {
  password: [
    {required: true, message: "新密码不能为空", trigger: "blur"}
  ],
  replyPwd: [
    {required: true, validator: checkReplyPwd, trigger: "blur"}
  ]
}

</script>

<template>
  <div class="flex_bt">
    <div class="flex_left">
      <div>
        <v-btn variant="text" icon="mdi-chevron-left" @click="router.back()"></v-btn>
      </div>
      <div>
        <v-breadcrumbs :items="props.bread"></v-breadcrumbs>
      </div>
    </div>
    <div class="flex_center">
      <div>
        <v-container
          fluid
        >
          <v-row justify="center">
            <v-menu
              min-width="200px"
              rounded
            >
              <template v-slot:activator="{ props }">
                <v-btn
                  icon
                  v-bind="props"
                >
                  <v-avatar
                    color="brown"
                    size="large"
                    v-if="!user.avatar"
                  >
                    <span class="text-h5">{{ cutName(user.fullName) }}</span>
                  </v-avatar>
                  <v-avatar
                    color="brown"
                    size="large"
                    :image="user.avatar"
                    v-else
                  >
                  </v-avatar>
                </v-btn>
              </template>
              <v-card>
                <v-card-text>
                  <div class="mx-auto text-center">
                    <v-avatar
                      color="brown"
                      :image="user.avatar"
                      v-if="!user.avatar"
                    >
                      <span class="text-h5">{{ cutName(user.fullName) }}</span>
                    </v-avatar>
                    <v-avatar
                      color="brown"
                      :image="user.avatar"
                      v-else
                    >
                    </v-avatar>
                    <h3>{{ user.fullName }}</h3>
                    <p class="text-caption mt-1">
                      {{ user.email }}
                    </p>
                    <v-divider class="my-3"></v-divider>
                    <v-btn
                      variant="text"
                      rounded
                      @click="handleEdit"
                    >
                      修改信息
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-row>
        </v-container>
      </div>
      <div class="mg_l_1 mg_r_2">
        <span style="color: #1d253b" v-html="user.fullName"></span>
      </div>
      <v-btn prepend-icon="mdi-logout" @click="handleLogout">
        登出
      </v-btn>
    </div>
  </div>
  <el-dialog
      v-model="open"
      title="温馨提示"
      width="500"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
  >
    <span>检测到该账号密码为初始密码，请修改密码</span>
    <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="formRules"
        label-width="auto"
        class="demo-ruleForm mg_t_3"
        :validate-on-rule-change="false"
        size="large">
      <el-form-item label="新密码：" prop="password">
        <el-input style="width: 350px" type="password" v-model="ruleForm.password" maxlength="16" show-password placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码：" prop="replyPwd">
        <el-input style="width: 350px" type="password" v-model="ruleForm.replyPwd" maxlength="16" show-password placeholder="请输入密码"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="submit">
          确认
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped>

</style>
